import { Theme, createStyles } from "@material-ui/core";
export const createCoursePlanStyle = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    similarHeader: {
      backgroundColor: "#fff",
      padding: "22px 25px",
      "& p": {
        fontSize: 24,
        fontWeight: 400,
        lineHeight: '33px',
      },
    },
    createCourseButton:{
        marginRight: '16px',
    }
  });
